module.exports = __webpack_public_path__ + "static/media/apron-backsplash.8f20ca9b.svg";